import React from 'react';
import Container from '@atoms/Container';
import Layout from '@components/Layout';
import { StyledButtonAsLink } from '../components/primitives/styled-button';
import CtaProvider from '../contexts/franchise/cta-provider';

const NotFoundPage = () => (
    <CtaProvider hideFranchiseLink>
        <Layout>
            <Container css={styles.containerStyles}>
                <h1 css={styles.headingStyles}>404 page not found</h1>
                <p css={styles.smallTextStyles}>It&apos;s like it never even happened...</p>
                <div
                    css={{
                        display: "flex",
                        marginBottom: "2.5rem",
                        justifyContent: "center"
                    }}>
                    <StyledButtonAsLink to="/">Let&apos;s get back to the action.</StyledButtonAsLink>
                </div>
                <div css={styles.videoContainerStyles}>
                    <div css={styles.videoContainerInnerStyles}>
                        <video
                            css={styles.videoStyles}
                            src="/404.mp4"
                            autoPlay
                            playsInline
                            muted
                            loop
                            preload
                        />
                    </div>
                </div>
            </Container>
        </Layout>
    </CtaProvider>
);

const styles = {
    containerStyles: {
        paddingTop: "3rem",
        paddingBottom: "3rem"
    },
    headingStyles: {
        marginBottom: "0.5rem",
        fontSize: "1.875rem",
        lineHeight: 1,
        textAlign: "center",
        color: "#C8C9C5",
        "@media (min-width: 768px)": {
            fontSize: "2.25rem",
            lineHeight: "2.5rem"
        },
        "@media (min-width: 1024px)": {
            marginBottom: "0.5rem",
            fontSize: "3rem",
            lineHeight: 1
        },
        "@media (min-width: 1536px)": {
            marginBottom: "1.25rem",
            color: "72px"
        }
    },
    smallTextStyles: {
        marginBottom: "1rem",
        fontSize: "1rem",
        lineHeight: "1.5rem",
        textAlign: "center",
        color: "#C8C9C5",
        "@media (min-width: 768px)": {
            fontSize: "1.25rem",
            lineHeight: "1.75rem"
        },
        "@media (min-width: 1024px)": {
            fontSize: "1.5rem",
            lineHeight: "2rem"
        },
        "@media (min-width: 1536px)": {
            marginBottom: "1.25rem",
            fontSize: "1.875rem",
            lineHeight: "2.25rem"
        }
    },
    videoContainerStyles: {
        display: "flex",
        justifyContent: "center"
    },
    videoContainerInnerStyles: {
        position: "relative",
        width: "55vw",
        overflow: "hidden",
        "&:before": {
            content: "''",
            display: "block",
            paddingTop: "44.8333%",
        }
    },
    videoStyles: {
        position: "absolute",
        top: "-3px",
        left: "-3px",
        height: "calc(100% + 6px)",
        width: "calc(100% + 6px)",
        maxWidth: "unset",
    }
};

export default NotFoundPage;
